module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HX3AWS/image/front.jpg?1718046581484",
      "alt": "This image is the cover for the book Minuet and Adorart"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Minuet and Adorart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Minuet and Adorart, our two celestial companions, yearn to descend to Earth and aid its inhabitants. Yet, before embarking on this noble mission, they must first seek approval from the Archangels. Sceptical of their capacity for such a monumental task, the higher celestial beings convene to deliberate. Meanwhile, our diminutive protagonists, undeterred by uncertainty, embark on a celestial flight, granting us a rare glimpse into the wonders of heaven. Through their eyes, we traverse sacred realms, witnessing breathtaking vistas and encountering profound revelations. Join us on this captivating journey as we soar alongside them, gaining insight and beholding the splendour of this ethereal realm. Will our angels ultimately fulfil their earthly calling? Discover the answer in this enchanting tale.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Christine Clarke\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("From a young age, Christine’s deep connection with God played a significant role in her life. Alongside her spirituality, she found joy in writing, though insecurities held her back, delaying her pursuit of publication for seven decades. As a Baby Boomer, she faced the challenges of a time when left-handed dyslexics were often deemed incapable by educators; as a result, her numerous manuscripts remained unseen. Yet, this year, with unwavering support from the Holy Spirit, Christine’s resilience blossomed. It was in this newfound strength that ‘The Two Small Angels’ came into being.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0